import React from "react";
import { newsItemType } from "../../../common/types/search/news";

export function Tags({ item }: { item: newsItemType }) {
	const isPaywalled = item.get("is_paywalled");
	const isExclusive = item.get("is_exclusive");
	const publishingChannel = item.get("publishing_channel");
	const defaultSegment = item.get("default_segment");
	const segmentText =
		defaultSegment === "BZA" ? "Business Jets" : "Commercial Aviation";

	const paywalledTag = isPaywalled && (
		<li className="tag other-publisher lock-icon">
			<img src="/static/img/icons/icon-locked-lock.svg" alt="" />
		</li>
	);
	const exclusiveTag = isExclusive && <li className="tag">Exclusive</li>;
	const segmentTag = <li className="tag aviation-segment">{segmentText}</li>;
	const publishingChannelTag = publishingChannel &&
		publishingChannel !== "ch-aviation" && (
			<li className="tag other-publisher">{publishingChannel}</li>
		);

	return (
		<ul className="post__tags">
			{paywalledTag}
			{exclusiveTag}
			{segmentTag}
			{publishingChannelTag}
		</ul>
	);
}
